//  for SEO metatags, FACE BOOK Open graph etc.

import React from "react"

function SEO({ title, description }) {
  React.useEffect(() => {
    document.title = title
    if (description) {
      var meta = document.createElement("meta")
      meta.setAttribute("name", "description")
      meta.setAttribute("content", description)
      document.getElementsByTagName("head")[0].appendChild(meta)
    }
  }, [])
  return <></>
}

export default SEO
/*
function addCss(url) {
  const link = document.createElement("link")
  link.rel = "stylesheet"
  link.href = url
  document.body.appendChild(link)
}

function addScript(url) {
  const script = document.createElement("script")
  script.src = url
  document.body.appendChild(script)
}
*/
